// extracted by mini-css-extract-plugin
export default {"warning":"Warning_warning__q2kTi","error":"Warning_error__EPROZ"};